module.exports = __webpack_public_path__ + "img/logo-fa-botton-gradiant.e0d18d9.svg";